<script setup lang="ts">

const {t} = useI18n()
const {$pwa} = useNuxtApp()

// Приймаємо пропси
const props = defineProps<{
  modelValue: boolean; // Для v-model
}>()

// Емітуємо події
const emit = defineEmits(['update:modelValue'])

// Локальна обчислювана властивість для v-model
const snackbar = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

// Оновлення сторінки зі спробою зберегти стан. Якщо новий service worker ще чекає своєї
// черги — спершу активуємо його (він сам перезавантажить сторінку), інакше стара вкладка
// так і лишилася б під старим SW.
const reload = async () => {
  if ($pwa?.needRefresh) {
    await $pwa.updateServiceWorker(true)
    return
  }
  reloadNuxtApp({persistState: true})
}
</script>

<template>
  <v-snackbar v-model="snackbar" color="primary" timeout="-1">
    <b>{{ t('updateNotification.title') }}</b><br />
    {{ t('updateNotification.text') }}
    <template v-slot:actions>
      <v-btn @click="reload">{{ t('buttons.refresh') }}</v-btn>
    </template>
  </v-snackbar>
</template>
